<template lang="pug">
  apollo-query(
    :query="query"
    :fetchPolicy="fetchPolicy"
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data } }")
      slot(
        :sentCurriculums="sentCurriculums"
        :draftCurriculums="draftCurriculums") Implement required
</template>

<script>
import { FETCH_CURRICULUMS_QUERY } from '@/graphql'
import createCurriculum from '@/entities/Curriculum'

export default {
  props: {
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_CURRICULUMS_QUERY,
      sentCurriculums: [],
      draftCurriculums: [],
    }
  },
  methods: {
    onResult(result) {
      this.sentCurriculums = result.data.viewer.sentCurriculums.edges.map((e) =>
        createCurriculum(e.node)
      )
      this.draftCurriculums = result.data.viewer.draftCurriculums.edges.map(
        (e) => createCurriculum(e.node)
      )
    },
  },
}
</script>
